import React, { useRef } from "react";
import "./Qualifications.css";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import { MdSchool } from "react-icons/md";
import { MdWork } from "react-icons/md";
const Qualifications = () => {
  return (
    <div className="qualifications">
      <h1 className="titlee">Education & Experience</h1>

      <VerticalTimeline>
        <VerticalTimelineElement
          className="vertical-timeline-element"
          contentStyle={{ background: "#fff", color: "#070606" }}
          contentArrowStyle={{ borderRight: "7px solid  rgb(0, 0, 0)" }}
          date="Education"
          iconStyle={{ background: "#070606", color: "#fff" }}
          icon={<MdSchool />}
        >
          <h3>High School</h3>
          <h4>P.Nazarov School No. 60</h4>

          <p>2018-2021 | Baku, Azerbaijan</p>
          
        </VerticalTimelineElement>
  

   <VerticalTimelineElement
          className="vertical-timeline-element"
          contentStyle={{ background: "#fff", color: "#070606" }}
          contentArrowStyle={{ borderRight: "7px solid  rgb(0, 0, 0)" }}
          date="Experience"
          iconStyle={{ background: "#070606", color: "#fff" }}
          icon={<MdWork />}
        >
          <h3>Frontend Developer(Intern)</h3>
          <h4>Kapital Bank OJSC</h4>
          <p> 6 Months | Baku, Azerbaijan</p>
          <ul>
            <li className="qual-list">
             Participating in Agile Development: I actively took part in agile development processes, including daily stand-up meetings. This allowed me to collaborate with the team, provide progress updates, and address any challenges. </li> <br /> <li className="qual-list">Integrating with APIs and Back-end Services: I worked on connecting our application with external APIs and back-end services. This involved fetching and displaying data from these sources to enhance the functionality of our application.</li> 
             
              
           
          </ul>
        </VerticalTimelineElement>

        <VerticalTimelineElement
          className="vertical-timeline-element"
          contentStyle={{ background: "#fff", color: "#070606" }}
          contentArrowStyle={{ borderRight: "7px solid  rgb(0, 0, 0)" }}
          date="Education"
          iconStyle={{ background: "#070606", color: "#fff" }}
          icon={<MdSchool />}
        >
          <h3>University of Łódź</h3>
          <h4>Computer Science and Mathematics</h4>

          <p>2021-2024 | Łódź, Poland</p>
          <ul>

          
          <li className="qual-list">
          Relevant courses included Data Structures and Algorithms, Databases,
            Object-oriented programming and Artificial Intelligence. </li> <br /> <li className="qual-list">Worked collaboratively with other students in team-based projects, managing team dynamics and contributing to project deliverables.</li> 
              <br />
              <li className="qual-list">Developed software projects from scratch using various programming languages, such as C#, Python, or C++.</li>
          
              </ul>
        </VerticalTimelineElement>
       
      </VerticalTimeline>
    </div>
  );
};

export default Qualifications;
